import script from "./ProtocoloAutoInfracao_31.vue?vue&type=script&setup=true&lang=js"
export * from "./ProtocoloAutoInfracao_31.vue?vue&type=script&setup=true&lang=js"

import "./ProtocoloAutoInfracao_31.vue?vue&type=style&index=0&id=e2f1af24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f1af24"]])

export default __exports__